import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import ResultJointCertificateSelectContent from '@/components/tax-refund/result/JointCertificate/select/ResultJointCertificateSelectContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const ResultJointCertificateSelectPage = () => {
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.인증정보입력);

  return (
    <Layout leftIcon={{ icon: 'back' }} rightTextButton={rightInquiryButton}>
      <ResultJointCertificateSelectContent />
    </Layout>
  );
};

export default ResultJointCertificateSelectPage;
